export const expandedColumns: Record<string, string[]> = {
  all: [
    'key-account-manager',
    'buyer',
    'total-order-cost',
    'origin',
    'finance',
    'destination',
    'delivery-option',
  ],
  sale: [
    'key-account-manager',
    'buyer',
    'total-order-cost',
    'origin',
    'finance',
    'destination',
    'delivery-option',
  ],
  profile: [
    'key-account-manager',
    'buyer',
    'total-order-cost',
    'origin',
    'finance',
    'destination',
    'delivery-option',
  ],
  logistic: [
    'key-account-manager',
    'buyer',
    'total-order-cost',
    'origin',
    'finance',
    'destination',
    'delivery-option',
  ],
  finance: [
    'payment-method',
    'payment-condition',
    'total-product-price',
    'total-freight-price',
    'tax-price',
    'total-payment',
    'expected-delivery-date',
    'shipment-destination',
    'delivery-at',
    'key-account-manager',
    'invoice-id',
    'credit',
    'finance',
  ],
  credit: [
    'key-account-manager',
    'finance',
    'total-product-price',
    'total-freight-price',
    'tax-price',
    'total-payment',
    'credit',
    'shipment-origin',
    'amount',
  ],
}
